import { Typography } from "@mui/material";
import GlobusScene from "@src/components/shared/Scenes/GlobusScene/GlobusScene";
import ShadowMapScene from "@src/components/shared/Scenes/ShadowMapScene/ShadowMapScene";
import TerrainScene from "@src/components/shared/Scenes/TerrainScene/TerrainScene";
import React from "react";
import { useParams } from "react-router";

const ScenePage: React.FC = () => {

    const { name } = useParams<"name">();

    switch (name) {
        case "globus":
            return <GlobusScene />;
        case "terrain":
            return <TerrainScene />;
        case "shadow-map":
            return <ShadowMapScene />
        default:
            return <Typography>Scene not found ¯\_(ツ)_/¯</Typography>;
    }
};

export default ScenePage;